import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Brewery } from '../interfaces/brewery';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BreweriesService {

  constructor(private https: HttpClient) { }

  getBreweries(){
    return this.https.get<Brewery[]>(environment.apiUrl+"breweries");
  }

  getBrewery(slug:string){
    return this.https.get<Brewery>(`${environment.apiUrl}breweries/user/${slug}`);
  }

}
